// SearchContext.tsx
import React, { ReactNode, createContext, useContext, useState, Dispatch, SetStateAction, useEffect } from 'react';
import { IRegionAreaModel } from '../types/IRegionAreaData';
import { IClubFilterOptions } from '../types/IClubSearch';
import { ToggleKey } from '../components/PlayerDetail/Candidates/ClubCandidateFilterSection';

export interface Team {
    value: string;
    label: string;
}

export interface ISelectedOption {
    region: string;
    optionId: number;
}

interface IClubContextType {
    isClubSearching: boolean;
    toggleClubSearch: () => void;
    clubSearchData?: any[];
    setClubSearchData?: ((data: any[]) => void) | undefined;
    clubSearchText: string; // Add searchText to the context state
    setClubSearchText: (text: string) => void;

    isSquadFilterChange: boolean;
    setIsSquadFilterChange: (value: boolean) => void;

    sortSquadOrderName: string;
    setSortSquadOrderName: (sortValue: string) => void;
    sortSquadOrdering: string;
    setSortSquadOrdering: (sortOrdering: string) => void;
    sortClubOrderName: string;
    setSortClubOrderName: (sortValue: string) => void;
    sortClubOrdering: string;
    setSortClubOrdering: (sortOrdering: string) => void;

    isClubSortFilterChange: boolean;
    setIsClubSortFilterChange: (value: boolean) => void;

    sortClubCandidateOrderName: string;
    setSortClubCandidateOrderName: (sortValue: string) => void;
    sortClubCandidateOrdering: string;
    setSortClubCandidateOrdering: (sortOrdering: string) => void;

    isClubCandidateSortFilterChange: boolean;
    setIsClubCandidateSortFilterChange: (value: boolean) => void;

    regionAreaData: IRegionAreaModel[] | undefined;
    setRegionAreaData: Dispatch<SetStateAction<IRegionAreaModel[] | undefined>>;
    regionAreaCandidateData: IRegionAreaModel[] | undefined;
    setRegionAreaCandidateData: Dispatch<SetStateAction<IRegionAreaModel[] | undefined>>;

    isClubFilterChange: boolean;
    setIsClubFilterChange: (value: boolean) => void;
    isClubCandidateFilterChange: boolean;
    setIsClubCandidateFilterChange: (value: boolean) => void;

    clubfilterValues: IClubFilterOptions;
    setClubFilterValues: (values: IClubFilterOptions) => void;

    clubRegionValues: ISelectedOption[];
    setClubRegionValues: React.Dispatch<React.SetStateAction<ISelectedOption[]>>;
    clubRegionCandidateValues: ISelectedOption[];
    setClubRegionCandidateValues: React.Dispatch<React.SetStateAction<ISelectedOption[]>>;

    isRevenueAnnual: boolean;
    setIsRevenueAnnual: (value: boolean) => void
    isWageAnnual: boolean;
    setIsWageAnnual: (value: boolean) => void;

    WagesPA: { min: number; max: number };
    setWagesPA: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    WagesPW: { min: number; max: number };
    setWagesPW: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    clubrevenuePA: { min: number; max: number };
    setclubRevenuePA: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    clubrevenuePW: { min: number; max: number };
    setclubRevenuePW: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    selectedclubWagesLabel: string;
    setSelectedClubWagesLabel: (value: string) => void;
    selectedclubRevenueLabel: string;
    setSelectedclubRevenueLabel: (value: string) => void;

    isFilterChange: boolean;
    setIsFilterChange: (value: boolean) => void

    currentPage: number;
    setCurrentPage: (value: number) => void;

    addedPlayers: any
    setAddedPlayers: any

    includeFinancial : boolean
    setInculdeFinancial : (value: boolean) => void
     includeCandidateFinancial : boolean
    setInculdeCandidateFinancial : (value: boolean) => void

    toggleAddButton: boolean;
    setIsToggleAddButton: (value: boolean) => void

    totalRevenue: { min: number; max: number };
    setTotalRevenue: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    totalCandidateRevenue: { min: number; max: number };
    setTotalCandidateRevenue: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    totalCost: { min: number; max: number };
    setTotalCost: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    totalCandidateCost: { min: number; max: number };
    setTotalCandidateCost: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    totalProfitLoss: { min: number; max: number };
    setTotalProfitLoss: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    totalCandidateProfitLoss: { min: number; max: number };
    setTotalCandidateProfitLoss: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    totalDebt: { min: number; max: number };
    setTotalDebt: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
     totalCandidateDebt: { min: number; max: number };
    setTotalCandidateDebt: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    retainedEraning: { min: number; max: number };
    setRetainedEraning: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    retainedCandidateEraning: { min: number; max: number };
    setRetainedCandidateEraning: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    assetsLiabilities: { min: number; max: number };
    setAssetsLiabilities: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    assetsCandidateLiabilities: { min: number; max: number };
    setCandidateAssetsLiabilities: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    debtVsAssetsRatio: { min: number; max: number };
    setDebtVsAssetsRatio: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
     debtVsAssetsCandidateRatio: { min: number; max: number };
    setDebtVsAssetsCandidateRatio: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    candidatesquadPurchaceAndCurrentRatio: { min: number; max: number };
    setCandidatesquadPurchaceAndCurrentRatio: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    totalIntangibleAssets: { min: number; max: number };
    setTotalIntangibleAssets: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
     totalIntangibleCandidateAssets: { min: number; max: number };
    setTotalIntangibleCandidateAssets: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    totalReceivables: { min: number; max: number };
    setTotalReceivables: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    totalCandidateReceivables: { min: number; max: number };
    setTotalCandidateReceivables: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    receivablesPercentage: { min: number; max: number };
    setReceivablesPercentage: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    receivablesCandidatePercentage: { min: number; max: number };
    setReceivablesCandidatePercentage: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    regionValues: ISelectedOption[];
    setRegionValues: React.Dispatch<React.SetStateAction<ISelectedOption[]>>;
    regionCandidateValues: ISelectedOption[];
    setRegionCandidateValues: React.Dispatch<React.SetStateAction<ISelectedOption[]>>;

    clubCurrentPage: number;
    setClubCurrentPage: (value: number) => void;
     clubCurrentCandidatePage: number;
    setClubCurrentCandidatePage: (value: number) => void;

    avgSquadValue: { min: number; max: number };
    setAvgSquadValue: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
     avgSquadCandidateValue: { min: number; max: number };
    setAvgSquadCandidateValue: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    squadPurchaseCostVSValue: { min: number; max: number };
    setSquadPurchaseCostVSValue: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    squadPurchaseCandidateCostVSValue: { min: number; max: number };
    setSquadPurchaseCandidateCostVSValue: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    avgSystemFit: { min: number; max: number };
    setAvgSystemFit: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
     avgCandidateSystemFit: { min: number; max: number };
    setAvgCandidateSystemFit: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    avgPlayerAge: { min: number; max: number };
    setAvgPlayerAge: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
     avgCandidatePlayerAge: { min: number; max: number };
    setAvgCandidatePlayerAge: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    wholeSquad: { min: number; max: number };
    setWholeSquad: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;
    
    wholeCandidateSquad: { min: number; max: number };
    setWholeCandidateSquad: React.Dispatch<React.SetStateAction<{ min: number; max: number }>>;

    minMaxData : any;
    setMinMaxData: any;
    minMaxCandidateData : any;
    setMinMaxCandidateData: any;


    clubCompareId: number;
    setIsClubCompareId: React.Dispatch<React.SetStateAction<number>>;

    compareClubLogoUrl: string;
    setCompareClubLogoUrl: React.Dispatch<React.SetStateAction<string>>;

    compareClubName: string;
    setCompareClubName: React.Dispatch<React.SetStateAction<string>>;

    clubSearchOpen : boolean;
    setIsClubSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;

    teamCompareAttributesData : any, 
    setTeamCompareAttributesData: any;

    toggles :Record<ToggleKey, boolean>;
    setToggles : React.Dispatch<React.SetStateAction<Record<ToggleKey, boolean>>>;
}

export interface IMinMaxData {
    minTotalRevenue: number;
    maxTotalRevenue: number;
    minTotalCost: number;
    maxTotalCost: number;
    minTotalProfitLoss: number;
    maxTotalProfitLoss: number;
    minTotalDebt: number;
    maxTotalDebt: number;
    minAssetsLiabilities: number;
    maxAssetsLiabilities: number;
    minDebtVsAssetsRatio: number;
    maxDebtVsAssetsRatio: number;
    minTotalIntangibleAssets: number;
    maxTotalIntangibleAssets: number;
    minTotalReceivables: number;
    maxTotalReceivables: number;
    minReceivablesPercentage: number;
    maxReceivablesPercentage: number;
    minAvSquadValue: number,
    maxAvSquadValue: number,
    minAvSystemFit: number,
    maxAvSystemFit: number,
    minAvPlayerAge: number,
    maxAvPlayerAge: number,
    minPurchaseVsMarketValue: number,
    maxPurchaseVsMarketValue: number,
    isPurchaseVsMarketValueWhole: boolean,
    minRetainedEarnings:number,
    maxRetainedEarnings:number
  }

const ClubSearchContext = createContext<Partial<IClubContextType>>({});

export const useClubSearch = (): IClubContextType => {
    const context = useContext(ClubSearchContext);
    if (!context) {
        throw new Error('useSearch must be used within a SearchProvider');
    }
    return context as IClubContextType;
};

export const ClubSearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const initialRegionValues: ISelectedOption[] = [];
    const [isClubSearching, setIsClubSearching] = useState(false);
    const [clubSearchText, setClubSearchText] = useState('');
    const [clubSearchData, setClubSearchData] = useState<Team[]>([]);
    const [isActive, setIsActive] = useState('');

    const [isSquadFilterChange, setIsSquadFilterChange] = useState(false);
    const [sortSquadOrderName, setSortSquadOrderName] = useState('Position');
    const [sortSquadOrdering, setSortSquadOrdering] = useState('ASC');

    const [isClubSortFilterChange, setIsClubSortFilterChange] = useState(false);
    const [sortClubOrderName, setSortClubOrderName] = useState('Revenue');
    const [sortClubOrdering, setSortClubOrdering] = useState('DESC');

    const [isClubCandidateSortFilterChange, setIsClubCandidateSortFilterChange] = useState(false);
    const [sortClubCandidateOrderName, setSortClubCandidateOrderName] = useState('Stylistic fit uplift');
    const [sortClubCandidateOrdering, setSortClubCandidateOrdering] = useState('DESC');

    const [minMaxData , setMinMaxData] = useState<IMinMaxData | undefined>();
    const [minMaxCandidateData , setMinMaxCandidateData] = useState<IMinMaxData | undefined>();


    const [isRevenueAnnual, setIsRevenueAnnual] = useState<boolean>(false)
    const [isWageAnnual, setIsWageAnnual] = useState<boolean>(false)
    const [WagesPA, setWagesPA] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });
    const [clubrevenuePA, setclubRevenuePA] = useState<{ min: number, max: number }>({ min: 0, max: 500000000 });
    const [WagesPW, setWagesPW] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });
    const [clubrevenuePW, setclubRevenuePW] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });
    const [selectedclubWagesLabel, setSelectedClubWagesLabel] = useState<string>("1");
    const [selectedclubRevenueLabel, setSelectedclubRevenueLabel] = useState<string>("1");
    const [isFilterChange, setIsFilterChange] = useState<boolean>(false)
    const [teamCompareAttributesData, setTeamCompareAttributesData] = useState();
    const [currentPage, setCurrentPage] = useState<number>(1);

    const [addedPlayers, setAddedPlayers] = useState<any>({});
    const [toggleAddButton, setIsToggleAddButton] = useState<boolean>();
    const [includeFinancial  , setInculdeFinancial] = useState<boolean>(false);
    const [includeCandidateFinancial  , setInculdeCandidateFinancial] = useState<boolean>(false);

    const [clubRegionValues, setClubRegionValues] = useState<ISelectedOption[]>([]);
    const [clubRegionCandidateValues, setClubRegionCandidateValues] = useState<ISelectedOption[]>([]);


    const [regionAreaData, setRegionAreaData] = useState<IRegionAreaModel[] | undefined>();
    const [regionAreaCandidateData, setRegionAreaCandidateData] = useState<IRegionAreaModel[] | undefined>();

    const initialClubFilterValues: IClubFilterOptions = {
        minRevenuePerWeek: 0,
        maxRevenuePerWeek: 0,
        minRevenueAnnual: 0,
        maxRevenueAnnual: 0,
        minAvWagePerWeek: 0,
        maxAvWagePerWeek: 0,
        minAvWageAnnual: 0,
        maxAvWageAnnual: 0,
        areaId: []
    }
    const [clubfilterValues, setClubFilterValues] = useState(initialClubFilterValues);
    const [isClubFilterChange, setIsClubFilterChange] = useState(false);
    const [isClubCandidateFilterChange, setIsClubCandidateFilterChange] = useState(false);

    const [totalRevenue, setTotalRevenue] = useState<{ min: number, max: number }>({min : 0 , max : 2000000000});
    const [totalCandidateRevenue, setTotalCandidateRevenue] = useState<{ min: number, max: number }>({min : 0 , max : 2000000000});

    const [totalCost, setTotalCost] = useState<{ min: number, max: number }>({ min: 0, max: 2000000000 });
    const [totalCandidateCost, setTotalCandidateCost] = useState<{ min: number, max: number }>({ min: 0, max: 2000000000 });

    const [totalProfitLoss, setTotalProfitLoss] = useState<{ min: number, max: number }>({ min: -500000000, max: 1000000000 });
    const [totalCandidateProfitLoss, setTotalCandidateProfitLoss] = useState<{ min: number, max: number }>({ min: -500000000, max: 1000000000 });

    const [totalDebt, setTotalDebt] = useState<{ min: number, max: number }>({ min: 0, max: 3000000000 });
    const [totalCandidateDebt, setTotalCandidateDebt] = useState<{ min: number, max: number }>({ min: 0, max: 3000000000 });

    const [retainedEraning, setRetainedEraning] = useState<{ min: number, max: number }>({ min: -1300000000, max: 520000000});
    const [retainedCandidateEraning, setRetainedCandidateEraning] = useState<{ min: number, max: number }>({ min: -1300000000, max: 520000000});

    const [assetsLiabilities, setAssetsLiabilities] = useState<{ min: number, max: number }>({ min: 0, max: 10});
    const [assetsCandidateLiabilities, setCandidateAssetsLiabilities] = useState<{ min: number, max: number }>({ min: 0, max: 10});

    const [debtVsAssetsRatio, setDebtVsAssetsRatio] = useState<{ min: number, max: number }>({ min: 0, max: 40 });
    const [debtVsAssetsCandidateRatio, setDebtVsAssetsCandidateRatio] = useState<{ min: number, max: number }>({ min: 0, max: 40 });
    const [candidatesquadPurchaceAndCurrentRatio, setCandidatesquadPurchaceAndCurrentRatio] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });

    const [totalIntangibleAssets, setTotalIntangibleAssets] = useState<{ min: number, max: number }>({ min: 0, max: 1000000000 });
    const [totalIntangibleCandidateAssets, setTotalIntangibleCandidateAssets] = useState<{ min: number, max: number }>({ min: 0, max: 1000000000 });

    const [totalReceivables, setTotalReceivables] = useState<{ min: number, max: number }>({ min: 0, max: 1000000000 });
    const [totalCandidateReceivables, setTotalCandidateReceivables] = useState<{ min: number, max: number }>({ min: 0, max: 1000000000 });

    const [receivablesPercentage, setReceivablesPercentage] = useState<{ min: number, max: number }>({ min: 0, max: 500 });
    const [receivablesCandidatePercentage, setReceivablesCandidatePercentage] = useState<{ min: number, max: number }>({ min: 0, max: 500 });

    const [avgSquadValue, setAvgSquadValue] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });
    const [avgSquadCandidateValue, setAvgSquadCandidateValue] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });

    const [squadPurchaseCostVSValue, setSquadPurchaseCostVSValue] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });
    const [squadPurchaseCandidateCostVSValue, setSquadPurchaseCandidateCostVSValue] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });


    // const [regularPurchaseCostValue , setRegularPurchaseCostValue] = useState<{ min: number, max: number }>({ min: 0, max: 180000000 });

    const [avgSystemFit, setAvgSystemFit] = useState<{ min: number, max: number }>({ min: 0, max: 100 });
    const [avgCandidateSystemFit, setAvgCandidateSystemFit] = useState<{ min: number, max: number }>({ min: 0, max: 100 });

    const [avgPlayerAge, setAvgPlayerAge] = useState<{ min: number, max: number }>({ min: 16, max: 55 });
    const [avgCandidatePlayerAge, setAvgCandidatePlayerAge] = useState<{ min: number, max: number }>({ min: 16, max: 55 });


    const [wholeSquad , setWholeSquad] =useState<{ min: number, max: number }>({ min: 0, max: 10 });
    const [wholeCandidateSquad , setWholeCandidateSquad] =useState<{ min: number, max: number }>({ min: 0, max: 10 });

    const [regionValues, setRegionValues] = useState<ISelectedOption[]>(initialRegionValues);
    const [regionCandidateValues, setRegionCandidateValues] = useState<ISelectedOption[]>(initialRegionValues);

    const [clubCurrentPage, setClubCurrentPage] = useState<number>(1);
    const [clubCurrentCandidatePage, setClubCurrentCandidatePage] = useState<number>(1);

    const [clubCompareId , setIsClubCompareId] = useState<number>(0);
    const [compareClubLogoUrl,setCompareClubLogoUrl] = useState<string>("");
    const [compareClubName,setCompareClubName] = useState<string>("");
    const [clubSearchOpen , setIsClubSearchOpen] = useState<boolean>(false)
    const [toggles, setToggles] = useState<Record<ToggleKey, boolean>>({
            affordability: true,
            wageOutlier: true,
            leagueWeighting: true,
            stylisticFit: true,
            systemFit: true,
        });
    
    
    useEffect(()=>{
        setTotalRevenue({min: minMaxData?.minTotalRevenue! , max : minMaxData?.maxTotalRevenue!})
        setTotalCost({min: minMaxData?.minTotalCost! , max : minMaxData?.maxTotalCost!})
        setTotalProfitLoss({min : minMaxData?.minTotalProfitLoss! , max : minMaxData?.maxTotalProfitLoss!})
        setTotalDebt({min : minMaxData?.minTotalDebt! , max : minMaxData?.maxTotalDebt!})
        setRetainedEraning({min : minMaxData?.minRetainedEarnings!, max : minMaxData?.maxRetainedEarnings!})
        setDebtVsAssetsRatio({min : minMaxData?.minDebtVsAssetsRatio! , max : minMaxData?.maxDebtVsAssetsRatio!})
        setTotalIntangibleAssets({min : minMaxData?.minTotalIntangibleAssets! , max : minMaxData?.maxTotalIntangibleAssets!})
        setTotalReceivables({min : minMaxData?.minTotalReceivables! , max : minMaxData?.maxTotalReceivables!})
        setReceivablesPercentage({min : minMaxData?.minReceivablesPercentage! , max : minMaxData?.maxReceivablesPercentage!})
        setAvgSquadValue({min : minMaxData?.minAvSquadValue! , max : minMaxData?.maxAvSquadValue!})
        setAvgSystemFit({min : minMaxData?.minAvSystemFit! , max : minMaxData?.maxAvSystemFit!})
        setAvgPlayerAge({min : minMaxData?.minAvPlayerAge! , max : minMaxData?.maxAvPlayerAge!})
        setSquadPurchaseCostVSValue({min : minMaxData?.minPurchaseVsMarketValue! , max : minMaxData?.maxPurchaseVsMarketValue!})
        
    },[minMaxData])

    useEffect(()=>{
        setTotalCandidateRevenue({min: minMaxCandidateData?.minTotalRevenue! , max : minMaxCandidateData?.maxTotalRevenue!})
        setTotalCandidateCost({min: minMaxCandidateData?.minTotalCost! , max : minMaxCandidateData?.maxTotalCost!})
        setTotalCandidateProfitLoss({min : minMaxCandidateData?.minTotalProfitLoss! , max : minMaxCandidateData?.maxTotalProfitLoss!})
        setTotalCandidateDebt({min : minMaxCandidateData?.minTotalDebt! , max : minMaxCandidateData?.maxTotalDebt!})
        setRetainedCandidateEraning({min : minMaxCandidateData?.minRetainedEarnings!, max : minMaxCandidateData?.maxRetainedEarnings!})
        setDebtVsAssetsCandidateRatio({min : minMaxCandidateData?.minDebtVsAssetsRatio! , max : minMaxCandidateData?.maxDebtVsAssetsRatio!})
        setTotalIntangibleCandidateAssets({min : minMaxCandidateData?.minTotalIntangibleAssets! , max : minMaxCandidateData?.maxTotalIntangibleAssets!})
        setTotalCandidateReceivables({min : minMaxCandidateData?.minTotalReceivables! , max : minMaxCandidateData?.maxTotalReceivables!})
        setReceivablesCandidatePercentage({min : minMaxCandidateData?.minReceivablesPercentage! , max : minMaxCandidateData?.maxReceivablesPercentage!})
        setAvgSquadCandidateValue({min : minMaxCandidateData?.minAvSquadValue! , max : minMaxCandidateData?.maxAvSquadValue!})
        setAvgCandidateSystemFit({min : minMaxCandidateData?.minAvSystemFit! , max : minMaxCandidateData?.maxAvSystemFit!})
        setAvgCandidatePlayerAge({min : minMaxCandidateData?.minAvPlayerAge! , max : minMaxCandidateData?.maxAvPlayerAge!})
        
    },[minMaxCandidateData])

    const toggleClubSearch = () => {
        setIsClubSearching(prev => !prev);
        setClubSearchData([]);
        setIsActive('Search');
    };


    return (
        <ClubSearchContext.Provider value={{
            isClubSearching,
            toggleClubSearch,
            clubSearchData,
            setClubSearchData,
            clubSearchText,
            setClubSearchText,

            isSquadFilterChange,
            setIsSquadFilterChange,
            sortSquadOrderName,
            setSortSquadOrderName,
            sortSquadOrdering,
            setSortSquadOrdering,

            isClubCandidateSortFilterChange,
            setIsClubCandidateSortFilterChange,
            sortClubCandidateOrdering,
            setSortClubCandidateOrdering,
            sortClubCandidateOrderName,
            setSortClubCandidateOrderName,

            isClubSortFilterChange,
            setIsClubSortFilterChange,

            sortClubOrderName,
            setSortClubOrderName,
            sortClubOrdering,
            setSortClubOrdering,

            regionAreaData,
            setRegionAreaData,

            isClubFilterChange,
            setIsClubFilterChange,
            clubfilterValues,
            setClubFilterValues,

            clubRegionValues,
            setClubRegionValues,

            isRevenueAnnual,
            setIsRevenueAnnual,

            isWageAnnual,
            setIsWageAnnual,

            WagesPA,
            setWagesPA,
            WagesPW,
            setWagesPW,

            clubrevenuePA,
            setclubRevenuePA,
            clubrevenuePW,
            setclubRevenuePW,

            selectedclubWagesLabel,
            setSelectedClubWagesLabel,
            selectedclubRevenueLabel,
            setSelectedclubRevenueLabel,

            isFilterChange,
            setIsFilterChange,

            currentPage,
            setCurrentPage,

            addedPlayers,
            setAddedPlayers,
            toggleAddButton,
            setIsToggleAddButton,

            totalRevenue,
            setTotalRevenue,
            totalCost,
            setTotalCost,
            totalProfitLoss,
            setTotalProfitLoss,
            totalDebt,
            setTotalDebt,
            retainedEraning,
            setRetainedEraning,
            debtVsAssetsRatio,
            setDebtVsAssetsRatio,
            totalIntangibleAssets,
            setTotalIntangibleAssets,
            totalReceivables,
            setTotalReceivables,
            receivablesPercentage,
            setReceivablesPercentage,
            regionValues,
            setRegionValues,
            clubCurrentPage,
            setClubCurrentPage,
            avgSquadValue,
            setAvgSquadValue,
            squadPurchaseCostVSValue,
            setSquadPurchaseCostVSValue,
            avgSystemFit,
            setAvgSystemFit,
            avgPlayerAge,
            setAvgPlayerAge,

            minMaxData,
            setMinMaxData,

            includeFinancial,
            setInculdeFinancial,

            assetsLiabilities,
            setAssetsLiabilities,

            wholeSquad,
            setWholeSquad,

            clubCompareId , 
            setIsClubCompareId,

            compareClubLogoUrl,
            setCompareClubLogoUrl,
            compareClubName,
            setCompareClubName,
            clubSearchOpen,
            setIsClubSearchOpen,
            includeCandidateFinancial  , setInculdeCandidateFinancial,
            minMaxCandidateData , setMinMaxCandidateData,
            clubRegionCandidateValues, setClubRegionCandidateValues,
            regionAreaCandidateData, setRegionAreaCandidateData,
            isClubCandidateFilterChange, setIsClubCandidateFilterChange,
            totalCandidateRevenue, setTotalCandidateRevenue,
            totalCandidateCost, setTotalCandidateCost,
            totalCandidateProfitLoss, setTotalCandidateProfitLoss,
            totalCandidateDebt, setTotalCandidateDebt,
            retainedCandidateEraning, setRetainedCandidateEraning,
            assetsCandidateLiabilities, setCandidateAssetsLiabilities,
            debtVsAssetsCandidateRatio, setDebtVsAssetsCandidateRatio,
            totalIntangibleCandidateAssets, setTotalIntangibleCandidateAssets,
            totalCandidateReceivables, setTotalCandidateReceivables,
            receivablesCandidatePercentage, setReceivablesCandidatePercentage,
            avgSquadCandidateValue, setAvgSquadCandidateValue,
            avgCandidateSystemFit, setAvgCandidateSystemFit,
            avgCandidatePlayerAge, setAvgCandidatePlayerAge,
            wholeCandidateSquad , setWholeCandidateSquad,
            regionCandidateValues, setRegionCandidateValues,
            clubCurrentCandidatePage, setClubCurrentCandidatePage,
            squadPurchaseCandidateCostVSValue, setSquadPurchaseCandidateCostVSValue,
            candidatesquadPurchaceAndCurrentRatio, setCandidatesquadPurchaceAndCurrentRatio,
            teamCompareAttributesData, setTeamCompareAttributesData,
            toggles, setToggles
        }}>
            {children}
        </ClubSearchContext.Provider>
    );
};